import React from 'react';
import { Box, Text } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { THEME_COLORS } from '../../theme/ThemeConstants';
import './MobileSidebarNav.scss';

interface MobileSidebarNavProps {
  onNavigate?: () => void;
}

interface NavItem {
  label: string;
  path: string;
  external?: boolean;
}

const navItems: NavItem[] = [
  {
    label: 'Store',
    path: '/'
  },
  {
    label: 'Main Site',
    path: 'https://trappedmc.com',
    external: true
  }
];

export const MobileSidebarNav: React.FC<MobileSidebarNavProps> = ({ onNavigate }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname === path;
  };

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  const renderNavItem = (item: NavItem) => {
    const active = !item.external && isActive(item.path);

    const content = (
      <Box
        className='mobile-nav-item'
        style={{
          padding: '12px 16px',
          backgroundColor: active ? 'rgba(255, 93, 2, 0.12)' : 'rgba(255, 255, 255, 0.04)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          borderRadius: 4,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          border: '1px solid',
          borderColor: active ? 'rgba(255, 93, 2, 0.25)' : 'rgba(255, 255, 255, 0.06)',
          borderLeftWidth: active ? 4 : 1,
          borderLeftColor: active ? THEME_COLORS.accent.primary : 'rgba(255, 255, 255, 0.06)',
          marginTop: 8
        }}
        onClick={handleClick}
      >
        <Text
          size='sm'
          c={active ? 'white' : THEME_COLORS.text.secondary}
          fw={active ? 600 : 500}
          className='mobile-nav-label'
        >
          {item.label}
        </Text>
      </Box>
    );

    if (item.external) {
      return (
        <a
          key={item.path}
          href={item.path}
          target='_blank'
          rel='noopener noreferrer'
          style={{ textDecoration: 'none', display: 'block' }}
        >
          {content}
        </a>
      );
    }

    return (
      <Link key={item.path} to={item.path} style={{ textDecoration: 'none', display: 'block' }}>
        {content}
      </Link>
    );
  };

  return (
    <Box className='mobile-sidebar-nav'>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 8
        }}
      >
        <Box
          style={{
            width: 3,
            height: 12,
            backgroundColor: THEME_COLORS.accent.primary,
            borderRadius: 1
          }}
        />
        <Text
          size='xs'
          fw={600}
          tt='uppercase'
          style={{
            letterSpacing: '0.08em',
            color: THEME_COLORS.text.dimmed
          }}
        >
          Navigate
        </Text>
      </Box>

      <Box style={{ display: 'flex', flexDirection: 'column' }}>{navItems.map((item) => renderNavItem(item))}</Box>
    </Box>
  );
};
